import React, { useEffect } from 'react'

const PhotographyRelease = ({onRenderReady,printRef}:any) => {

    useEffect(() => {
            onRenderReady?.();
    }, []);

    return (
        <div>
            <div className='mt-5 px-5' id='photography-release' ref={printRef} style={{ pageBreakAfter: "always" }}>
                <p className='f-f fs-16'>
                    I, Michael Lapin, of Michael Lapin Photography authorize Airoom, Inc. and Airoom Architects, Inc. the unrestricted rights to any of my photography in print, film or digital form prepared for Airoom, Inc. and/or Airoom Architects, Inc.
                </p>
                <div className='row'>
                    <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                        <div className='d-flex'>
                            <div className='f-f'>
                                Signed:
                            </div>

                            <div className='w-100' style={{ borderBottom: '1px solid black' }} />
                        </div>
                        <p className='mb-0 ms-5 f-f'>
                            Michael Lapin
                        </p>
                    </div>
                    <div className='col-md-4' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                        <div className='d-flex'>
                            <div className='f-f'>
                                Date:
                            </div>
                            <div className='w-100' style={{ borderBottom: '1px solid black' }} />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default PhotographyRelease
